import e from "../../utils/classNames.js";
import t from "../selects/Select.js";
import { useEffect as n, useState as r } from "react";
import { noop as i } from "es-toolkit/compat";
import { jsx as a } from "react/jsx-runtime";
//#region src/components/table/TableViewToggles.tsx
var o = {
	TABLE: "icon-table-view",
	SINGLE_CARD: "icon-th-list",
	MULTI_CARDS: "icon-split-view"
}, s = (s) => {
	let { viewType: c, initialViewType: l = "TABLE", disabledViewTypes: u = [], onViewTypeChange: d = i, tableViewTooltipContent: f, tableViewLabel: p, singleCardViewTooltipContent: m, singleCardViewLabel: h, multiCardsViewTooltipContent: g, multiCardsViewLabel: _, disabled: v = !1, className: y, ...b } = s, [x, S] = r(l);
	n(() => {
		c && S(c);
	}, [c]);
	let C = (e) => {
		S(e), d(e);
	}, w = [
		{
			id: "TABLE",
			label: p ?? f ?? "",
			icon: /* @__PURE__ */ a("span", { className: `uikit-icon ${o.TABLE}` })
		},
		{
			id: "MULTI_CARDS",
			label: _ ?? g ?? "",
			icon: /* @__PURE__ */ a("span", { className: `uikit-icon ${o.MULTI_CARDS}` })
		},
		{
			id: "SINGLE_CARD",
			label: h ?? m ?? "",
			icon: /* @__PURE__ */ a("span", { className: `uikit-icon ${o.SINGLE_CARD}` })
		}
	], T = w.filter((e) => !u.includes(e.id)), E = w.some((e) => e.label), D = e("TableViewToggles", y && y);
	return /* @__PURE__ */ a("div", {
		...b,
		className: D,
		children: /* @__PURE__ */ a("div", {
			className: "form-group margin-bottom-0",
			children: /* @__PURE__ */ a(t, {
				options: T,
				value: [x],
				onChange: (e) => e && C(e.id),
				disabled: v,
				showSelectedItemIcon: !0,
				pullRight: !0,
				dropdownClassName: E ? void 0 : "width-auto"
			})
		})
	});
};
s.VIEW_TYPE_TABLE = "TABLE", s.VIEW_TYPE_SINGLE_CARD = "SINGLE_CARD", s.VIEW_TYPE_MULTI_CARDS = "MULTI_CARDS";
//#endregion
export { s as default };

//# sourceMappingURL=TableViewToggles.js.map